import format from 'date-fns/format';
import router from 'next/router';
import {MouseEvent, useCallback} from 'react';
import {Icon} from '../../../../design-system/atoms/Icon/Icon';
import {IconType} from '../../../../design-system/atoms/Icon/IconType.enum';
import {Text} from '../../../../design-system/atoms/Text/Text';
import {ExpiredCredit} from '../../../../graphql/generated/types';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {t} from '../../../getTranslations';
import {openWindow} from '../../../openWindow.function';
import {formatWithCommasAndDefaultHyphen} from '../../../shared/utils/formatWithCommasAndDefaultHyphen';
import {TotalBalanceProps} from './TotalBalanceProps.interface';

export function TotalBalance({
  isMobile,
  totalBalance,
  paidSum,
  eventSum,
  expiredCredit,
  isGlobal,
}: TotalBalanceProps) {
  const onClickCashReceipts = useCallback(
    (e: MouseEvent) => {
      LOG_CLICK_EVENT('현금영수증발급정보_클릭', e, () => {
        if (isMobile) {
          router.push('/billing/cashreceipts');
        } else {
          openWindow({
            url: '/billing/cashreceipts',
            target: 'cashreceipts',
            features: 'width=360, height=680',
          });
        }
      });
    },
    [isMobile]
  );

  return (
    <div className="font-small2 bg-theme-bg-surface-alt py-20pxr px-15pxr">
      <Text className="font-medium2-bold text-theme-solid-100">
        {totalBalance}
      </Text>
      <Text className="font-small2 ml-4pxr text-theme-solid-100">
        {t('common_cash')}
      </Text>
      <div className="mt-8pxr flex text-theme-solid-60">
        <Icon type={IconType.ContentHomeLowRank} className="mr-4pxr" />
        <Text className="flex-1">
          {t('cash_history_purchased_cash')}{' '}
          {!isGlobal && (
            <Text
              className="cursor-pointer underline"
              onClick={onClickCashReceipts}
            >
              {t('cash_history_receipt_info')}
            </Text>
          )}
        </Text>
        <Text className="font-small2-bold text-theme-solid-100">{paidSum}</Text>
      </div>
      <div className="mt-8pxr flex text-theme-solid-60">
        <Icon type={IconType.ContentHomeLowRank} className="mr-4pxr" />
        <Text className="flex-1">{t('cash_history_event_cash')}</Text>
        <Text className="text-theme-solid-100">{eventSum}</Text>
      </div>
      {expiredCredit && (
        <div className="mt-12pxr flex text-theme-solid-60">
          <Text>
            ·{' '}
            {t('cash_history_event_cash_info', {
              values: {
                value: formatWithCommasAndDefaultHyphen(
                  expiredCredit,
                  (param: ExpiredCredit) => param.expiredSum
                ),
                date: format(
                  new Date(expiredCredit.expiredAt),
                  t('date_formatter_year_less')
                ),
              },
            })}
          </Text>
        </div>
      )}
    </div>
  );
}
